import { render, staticRenderFns } from "./OrderShippingUpdates.vue?vue&type=template&id=646e11bf&scoped=true"
import script from "./OrderShippingUpdates.vue?vue&type=script&lang=js"
export * from "./OrderShippingUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e11bf",
  null
  
)

export default component.exports